import Layout from '@/layout'

const route = {
  path: '/hugeAdvertGroup',
  component: Layout,
  redirect: '/hugeAdvertGroup/index',
  alwaysShow: true, // will always show the root menu
  name: 'hugeAdvertGroup',
  meta: {
    title: '短剧剪辑数据',
    icon: 'ANRM',
    roles: [
      'ad_name_report.manage'
    ]
  },
  children: [
    {
      path: '/hugeAdvertGroup/releaseGroupList/index',
      component: () => import('@/views/hugeAdvertGroup/releaseGroupList/index.vue'),
      name: 'releaseGroupList',
      meta: {
        title: '投放组列表',
        icon: 'component',
        roles: [
          'bind_groups.index'
        ]
      }
    },
    {
      path: '/hugeAdvertGroup/bindingRelationList/index',
      component: () => import('@/views/hugeAdvertGroup/bindingRelationList/index.vue'),
      name: 'bindingRelationList',
      meta: {
        title: '绑定关系列表',
        icon: 'component',
        roles: [
          'bind_relations.index'
        ]
      }
    }, {
      path: '/hugeAdvertGroup/reportList/index',
      component: () => import('@/views/hugeAdvertGroup/reportList/index.vue'),
      name: 'reportList',
      meta: {
        title: '报表列表',
        icon: 'component',
        roles: [
          'ad_name_report.report_list'
        ]
      }
    }, {
      path: '/hugeAdvertGroup/totalReportList/index',
      component: () => import('@/views/hugeAdvertGroup/totalReportList/index.vue'),
      name: 'totalReportList',
      meta: {
        title: '总计报表',
        icon: 'component',
        roles: [
          'ad_name_report.total_report'
        ]
      }
    }
  ]
}

export default route
